import type { FaireProductEntity } from "../../entity_types/product";

export const p_cbwragr2f6: FaireProductEntity = {
  token: "p_cbwragr2f6",
  type: "product",
  name: "ALO Comfort/12 pack of 10.8 FL OZ slim cans",
  brandToken: "b_7h76tk1dcp",
  brandName: "ALO drink",
  imageUrl:
    "https://cdn.faire.com/fastly/a80d457f581e2cea185e7b74df6a0fad7172dae3d50e3de4e0a1c436b584799d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fe7db964e444dc31bbefab49cf5c5fad9d72eea8bc4c1811a94ed05d8f6327f6.jpeg",
    "https://cdn.faire.com/fastly/7174cba582fb5826bf1955380b90a16a2bba1ecb92f9c2f68b66ba6b8a2a8323.jpeg",
  ],
  priceDollars: 1.87,
  description:
    "12 pack of 10.8 FL OZ slim cans\n\nALO Comfort\n\nIT’S JUST PEACHY TO DRINK WATERMELON\nThe comforting combo of watermelon and peach will make you smile all day. It’s a bright flavor combination that satisfies as it refreshes.\n\n * Sweetened with cane sugar \n * Aloin-Free \n * No Artificial Flavors, Preservatives or Colors \n * Real aloe vera juice & pulp – never from powder \n * \n * \n * \n * ",
  tags: [],
  msrpDollars: 3.74,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:28.219Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
